import 'es6-promise/auto';
// import Vuex from 'vuex';
// import Vue from 'vue';
import actions from './action';
import getters from './getters';
import mutations from './mutations';

// Vue.use(Vuex);

const state = {
	token: null,
	permissions: null,
	currentUser: {},
	fileCommand: null,
    selectMenu: {},
    testReport: [],
    currentLesson: {},
    uploadCode: '',
    expandPreviewCode: '',
    cancelMenu: {},
    isPrivacy: '',
    isEye: false,
    hasOldEntrance:false,
    playFlag: false,
};

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations
});



// WEBPACK FOOTER //
// ./src/store/store.js